import { createAction } from '@reduxjs/toolkit';

export const REMOVED_CARD_ACTION_TYPE = 'saga/removeCard';
export const removeCardAction = createAction(REMOVED_CARD_ACTION_TYPE);
